import { Card, CardContent, Hidden, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  numberFormat,
  participationsFormat,
} from "../../../helpers/numberFormat";

export const TotalPositionsClub = ({ investmentList, divestmentList }) => {
  const { t } = useTranslation("global");
  const totalAmountInvestment = investmentList
    .map((invest) => invest.amount)
    .reduce((a, b) => a + b, 0);
  const capitalGainInvestment = investmentList
    .map((invest) =>
      invest.investmentType !== "Préstamo Convertible"
        ? (invest.amount / invest.participationValuation) * invest.newAmount -
          invest.amount
        : 0
    )
    .reduce((a, b) => a + b, 0);

  const totalAmountDivestment = divestmentList
    .map(
      (divest) => divest.divestmentParticipation * divest.participationValuation
    )
    .reduce((a, b) => a + b, 0);
  const capitalGainDivestment =
    divestmentList
      .map((divest) => divest.divestmentParticipation * divest.salesPrice)
      .reduce((a, b) => a + b, 0) - totalAmountDivestment;

  const totalInvest = totalAmountInvestment + totalAmountDivestment;
  const capitalGain = capitalGainInvestment + capitalGainDivestment;

  return (
    <Hidden mdDown>
      <Stack direction="row" gap={4} justifyContent="space-around">
        <Card sx={{ width: "300px" }}>
          <CardContent>
            <Typography
              gutterBottom
              textAlign="center"
              sx={{ fontWeight: "bold" }}
              variant="body1"
              color="primary"
            >
              {t("totalPosition.latent")}
            </Typography>
            <Stack direction="row" justifyContent="space-around">
              <Stack>
                <Typography
                  textAlign="center"
                  variant="body2"
                  sx={{ fontWeight: "bold" }}
                  color="primary"
                >
                  {t("totalPosition.investment")}
                </Typography>
                <Typography
                  textAlign="center"
                  variant="body2"
                  color="secondary"
                >
                  {numberFormat(totalAmountInvestment.toFixed(2))}
                </Typography>
              </Stack>
              <Stack>
                <Typography
                  textAlign="center"
                  variant="body2"
                  sx={{ fontWeight: "bold" }}
                  color="primary"
                >
                  {t("totalPosition.capitalGains")}
                </Typography>
                <Typography
                  textAlign="center"
                  variant="body2"
                  color="secondary"
                >
                  {numberFormat(capitalGainInvestment.toFixed(2))}
                </Typography>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ width: "300px" }}>
          <CardContent>
            <Typography
              gutterBottom
              textAlign="center"
              sx={{ fontWeight: "bold" }}
              variant="body1"
              color="primary"
            >
              {t("totalPosition.realized")}
            </Typography>
            <Stack direction="row" justifyContent="space-around">
              <Stack>
                <Typography
                  textAlign="center"
                  variant="body2"
                  sx={{ fontWeight: "bold" }}
                  color="primary"
                >
                  {t("totalPosition.investment")}
                </Typography>
                <Typography
                  textAlign="center"
                  variant="body2"
                  color="secondary"
                >
                  {numberFormat(totalAmountDivestment.toFixed(2))}
                </Typography>
              </Stack>
              <Stack>
                <Typography
                  textAlign="center"
                  variant="body2"
                  sx={{ fontWeight: "bold" }}
                  color="primary"
                >
                  {t("totalPosition.capitalGains")}
                </Typography>
                <Typography
                  textAlign="center"
                  variant="body2"
                  color="secondary"
                >
                  {numberFormat(capitalGainDivestment.toFixed(2))}
                </Typography>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ width: "300px" }}>
          <CardContent>
            <Typography
              gutterBottom
              textAlign="center"
              sx={{ fontWeight: "bold" }}
              variant="body1"
              color="primary"
            >
              {t("totalPosition.global")}
            </Typography>
            <Stack direction="row" justifyContent="space-around">
              <Stack>
                <Typography
                  textAlign="center"
                  variant="body2"
                  sx={{ fontWeight: "bold" }}
                  color="primary"
                >
                  {t("totalPosition.investment")}
                </Typography>
                <Typography
                  textAlign="center"
                  variant="body2"
                  color="secondary"
                >
                  {numberFormat(totalInvest.toFixed(2))}
                </Typography>
              </Stack>
              <Stack>
                <Typography
                  textAlign="center"
                  variant="body2"
                  sx={{ fontWeight: "bold" }}
                  color="primary"
                >
                  {t("totalPosition.capitalGains")}
                </Typography>
                <Typography
                  textAlign="center"
                  variant="body2"
                  color="secondary"
                >
                  {numberFormat(capitalGain.toFixed(2))}
                </Typography>
              </Stack>

              <Stack>
                <Typography
                  textAlign="center"
                  variant="body2"
                  sx={{ fontWeight: "bold" }}
                  color="primary"
                >
                  TVPI:
                </Typography>
                <Typography
                  textAlign="center"
                  variant="body2"
                  color="secondary"
                >
                  {participationsFormat(
                    (capitalGain + totalInvest) / totalInvest
                  )}
                  x
                </Typography>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
    </Hidden>
  );
};
